<template>
    <div>
      <div
        v-if="show"
        @mouseover="mouseover"
        @mouseout="mouseout"
        class="box"
        :style="{ top: top + 'px', left: left + 'px' }"
        @click="gologin"
      >
        <span @click="close"><i class="el-icon-close"></i></span>
        <!-- <div>{{ content }}</div> -->
        <img src="https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240416/b38e6ebbcdd77b6cba58aa44e0b01f01.png" alt="">
      </div>
    </div>
  </template>
   <script>
   export default {
     name: 'MoveWindow',
     props: {
       content: {
         default: '友情提示：这是一个飘窗测试，鼠标悬浮停止运动。',
       },
     },
     data() {
       return {
         show: false,
         stepX: 1,
         stepY: 1,
         timer: null,
         maxTop: 0,
         maxLeft: 0,
         top: 0,
         left: 0,
       }
     },
    //  props:{
    //     contentImg
    //  },
     mounted() {
       this.init()
       
     },
     beforeDestroy() {
       // dom 销毁前清除定时器
       clearInterval(this.timer)
     },
     methods: {
       init() {
         this.maxTop = document.documentElement.clientHeight - 150 - 5
         this.maxLeft = document.documentElement.clientWidth - 200 - 5
         this.top = 0
         this.left = 0
         clearInterval(this.timer)
         this.timer = setInterval(() => {
           this.move()
         }, 20)
         this.onresize()
       },
       gologin(){
        console.log("注册");
        this.$router.push({
		    path: '/bxbk',
		    name: "/bxbk",
		   
		  });
       },
    
       // 移动函数
    
       move() {
         if (this.top >= this.maxTop || this.top < 0) {
           this.stepY = -this.stepY
         }
         if (this.left >= this.maxLeft || this.left < 0) {
           this.stepX = -this.stepX
         }
         this.top += this.stepY
         this.left += this.stepX
       },
    
       mouseover() {
         clearInterval(this.timer)
       },
    
       mouseout() {
         clearInterval(this.timer)
         this.timer = setInterval(() => {
           this.move()
         }, 20)
       },
    
       close() {
         clearInterval(this.timer)
         this.show = false
       },
    
       onresize() {
         const that = this
         window.onresize = function () {
           that.init()
         }
       },
     },
   }
   </script>
  <style scoped>
  .box {
    /* background: #6e86f2; */
    width: 350px;
    height: 170px;
    border-radius: 5px;
    position: fixed;
    text-align: left;
    padding: 10px;
    color: #ffffff;
    top: 0;
    left: 0;
    z-index: 9999
  }
  .box img{
    /* width: 230px;
    height: 170px; */
  }
  .box > span {
    text-align: right;
    position: absolute;
    right: 30px;
    top: 28px;
    color: #1b1d20;
    cursor: pointer;
  }
   
  .box > div {
    margin-top: 30px;
  }
  </style>